<template>
    <div class="container">
        <div class="row carousel-img-height">
            <div class="col-12">
                <img :src="imageSource()">
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="header">{{ header() }}</div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="text">{{ text() }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CarouselPage",
        props: {
            "stage": {
                type: Number
            }
        },
        methods: {
            imageSource() {
                switch (this.stage) {
                    case 1:
                        return require("@/assets/bus_stage.svg");
                    case 2:
                        return require("@/assets/nav_stage.svg");
                    case 3:
                        return require("@/assets/travel_stage.svg");
                }
                return "";
            },
            header() {
                switch (this.stage) {
                    case 1:
                        return this.$i18n.t("carousel.stage.bus.header");
                    case 2:
                        return this.$i18n.t("carousel.stage.nav.header");
                    case 3:
                        return this.$i18n.t("carousel.stage.travel.header");
                }
                return "";
            },
            text() {
                switch (this.stage) {
                    case 1:
                        return this.$i18n.t("carousel.stage.bus.text");
                    case 2:
                        return this.$i18n.t("carousel.stage.nav.text");
                    case 3:
                        return this.$i18n.t("carousel.stage.travel.text");
                }
                return "";
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../scss/color_palette";
    .carousel-img-height {
        height: 33vh;
        &>div {
            height: 100%;
            &>img {
                width: 100%;
                height: 100%;
            }
        }
    }
    @media only screen and (min-height: 600px) {
        [class*="carousel-img-height"] {
            height: 50vh;
        }
    }

    .header {
        margin-top: 10px;
        font-weight: bold;
        font-size: 16px;
    }

    .text {
        margin-top: 10px;
        font-size: 14px;
        font-weight: 500;
        color: black("70");
    }

    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 370px) {
        .header {
            font-size: 20px;
        }

        .text {
            font-size: 18px;
        }
    }

    @media (-webkit-min-device-pixel-ratio: 3) and (min-width: 360px) {
        .header {
            font-size: 20px;
        }

        .text {
            font-size: 18px;
        }
    }
</style>
